import React from 'react';
import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';

const MenuPersonasSSV = ({ idPersona, idEncuesta }) => {
    const items = [
        {
            id: 'tabDatosBasicos',
            href: `/encuestassv/datosbasicos/${idPersona}/${idEncuesta}`,
            label: 'A. DATOS BASICOS',
            backgroundColor: '#94c1fc',
            borderColor: '#365480',
            textColor: '#000000',
        },
        {
            id: 'tabSalud',
            href: `/encuestassv/salud/${idPersona}/${idEncuesta}`,
            label: 'B. SALUD',
            backgroundColor: '#94c1fc',
            borderColor: '#365480',
            textColor: '#000000',
        },
        {
            id: 'tabEduc',
            href: `/encuestassv/educacion/${idPersona}/${idEncuesta}`,
            label: 'C. EDUCACIÓN',
            backgroundColor: '#94c1fc',
            borderColor: '#365480',
            textColor: '#000000',
        },
        {
            id: 'tabFuerTrab',
            href: `/encuestassv/fuerzatrabajo/${idPersona}/${idEncuesta}`,
            label: 'E. FUERZA DE TRABAJO (Ingresos)',
            backgroundColor: '#94c1fc',
            borderColor: '#365480',
            textColor: '#000000',
        },
        {
            id: 'tabOtroIng',
            href: `/encuestassv/otrosingresos/${idPersona}/${idEncuesta}`,
            label: 'F. OTROS INGRESOS',
            backgroundColor: '#94c1fc',
            borderColor: '#365480',
            textColor: '#000000',
        },
        {
            id: 'tabPerPro',
            href: `/encuestassv/perfilproductivo/${idPersona}/${idEncuesta}`,
            label: 'H. PERFIL PRODUCTIVO',
            backgroundColor: '#94c1fc',
            borderColor: '#365480',
            textColor: '#000000',
        },
    ];

    return (
        <Nav
            as="ul"
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                gap: '12px',
                listStyle: 'none',
                padding: 0,
                margin: 0,
            }}
        >
            {items.map((item) => (
                <Nav.Item as="li" id={item.id} key={item.id}>
                    <Nav.Link
                        href={item.href}
                        aria-expanded="true"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            minHeight: '84px',
                            padding: '14px 16px',
                            border: `1px solid ${item.borderColor}`,
                            borderRadius: '12px',
                            backgroundColor: item.backgroundColor,
                            boxShadow: '0 4px 14px rgba(15, 23, 42, 0.12)',
                            color: item.textColor,
                            fontWeight: 600,
                            textDecoration: 'none',
                        }}
                    >
                        <i id="semident" className="fa fa-circle" style={{ color: item.textColor }}></i>
                        <span>{item.label}</span>
                    </Nav.Link>
                </Nav.Item>
            ))}
        </Nav>
    );
};

MenuPersonasSSV.propTypes = {
    idPersona: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    idEncuesta: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default MenuPersonasSSV;